
export interface LoginState {
  isLoggedIn: boolean;
}


export function useLoginState(): LoginState {

  const isLoggedIn = !!localStorage.getItem("access_token");
  return { isLoggedIn };

}
